import styled from 'styled-components'

const ModalWrapper = styled.div`
  display: flex;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Score = styled.span`
  font-size: ${props => props.fontSize ? props.fontSize : props.theme.fontSizes.medium}};
  font-weight: ${props => props.theme.fontWeight.semiBold};
  color: ${props => props.color};
`

const Dashboard = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  background: ${props => props.theme.colors.white};

  margin: 1rem 0;
  padding: 1rem 0;

  box-shadow: 1px 1px 30px 1px rgba(15, 17, 38, 0.05);
  border-radius: 12px;
`

const Dot = styled.span`
  height: 10px;
  width: 10px;
  background-color: ${props => props.bg};
  border-radius: 50%;
  display: inline-block;

  margin: 0 1rem;
`

export {ModalWrapper, Wrapper, Score, Dashboard, Dot}